// @flow

import * as React from 'react';

import styles from './CallToAction.scss';

type Props = {
  children: React.Node,
};

export default function CallToAction(props: Props): React.MixedElement {
  const { children } = props;

  return <p className={styles.root}>{children}</p>;
}
